import { createContext } from 'react';

export type Environment = 'production' | 'staging' | 'development';

export interface EnvironmentContextType {
    environment: Environment;
    isProd: boolean;
    isStaging: boolean;
    isDev: boolean;
}

export const EnvironmentContext = createContext<EnvironmentContextType | undefined>(undefined);